export const intersperse = <T>(obj: T, arr: T[]): T[] => {
  const len = arr.length;
  if (len === 0) {
    return [];
  } else if (len === 1) {
    return arr.slice(0);
  } else {
    const items = [arr[0]];
    for (let i = 1; i < len; ++i) {
      items.push(obj, arr[i]);
    }
    return items;
  }
};

export const headOfMaybe = <T>(x: T[]): undefined | T => (x != null ? x[0] : undefined);

export const lengthOfMaybe = (x: any[]): number => (x != null ? x.length : 0);

export const catMaybes = <T>(xs: Array<undefined | null | T>): T[] =>
  xs.filter((x) => x !== undefined && x !== null) as T[];

export function chunks<A>(chunkSize: number, xs: Array<A>) {
  const result: Array<Array<A>> = [];
  for (let i = 0; i < xs.length; i += chunkSize) {
    result.push(xs.slice(i, i + chunkSize));
  }
  return result;
}
